const DON_KING_URL = process.env.REACT_APP_DON_KING_URL || '';

export interface ChatMessage {
  role: 'user' | 'model';
  parts: string[];
}

export async function fetchSuggestions(
  machineId: string,
  bearerToken: string,
  problemDescription?: string,
  signal?: AbortSignal,
): Promise<string> {
  if (!DON_KING_URL) {
    throw new Error('REACT_APP_DON_KING_URL is not configured');
  }

  const response = await fetch(`${DON_KING_URL}/api/suggestions`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearerToken}`,
    },
    body: JSON.stringify({
      machine_id: machineId,
      problem_description: problemDescription || null,
    }),
    signal,
  });

  if (!response.ok) {
    const text = await response.text().catch(() => String(response.status));
    throw new Error(`don-king error (${response.status}): ${text}`);
  }

  const data = await response.json();
  return data.suggestions as string;
}

export async function sendChatMessage(
  machineId: string,
  bearerToken: string,
  message: string,
  conversationHistory: ChatMessage[],
  problemDescription?: string
): Promise<string> {
  if (!DON_KING_URL) {
    throw new Error('REACT_APP_DON_KING_URL is not configured');
  }

  const response = await fetch(`${DON_KING_URL}/api/chat`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearerToken}`,
    },
    body: JSON.stringify({
      machine_id: machineId,
      message,
      problem_description: problemDescription || null,
      conversation_history: conversationHistory,
    }),
  });

  if (!response.ok) {
    const text = await response.text().catch(() => String(response.status));
    throw new Error(`don-king error (${response.status}): ${text}`);
  }

  const data = await response.json();
  return data.reply as string;
}
